<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header">
        <h3>Novo tópico</h3>
      </div>

      <div>
        
      </div>

      <div slot="body" style="margin:0px;">
        <textarea v-model="newtopic.text" 
        style="width:100%; 
              min-width: 100%; 
              max-width: 100%; 
              resize: vertical; 
              height: 100%;
              max-height: 400px;
              min-height: 100px;" rows="9"></textarea>
      </div>

      <div slot="footer">
        <select  @change="onChangeCourse($event)" 
          v-model="course" 
          id="course"
          style="width: 35%; margin-left: 20px !important; margin-right: 10px; height: 35px">
          <option :value="null">Curso</option>
          <option
              v-for="course in courses"
              v-bind:key="course.id"
              v-bind:value="course.id"
            >{{course.name}}</option>
        </select>

        <select  @change="onChangeModule($event)" 
          v-model="module" 
          id="module"
          style="width: 35%; margin-left: 0px !important; margin-right: 10px; height: 35px">
            <option :value="null">Módulo</option>
            <option
                v-for="module in modules"
                v-bind:key="module.id"
                v-bind:value="module.id"
              >{{module.name}}</option>
          </select>

        <lms-button :disabled="saving" @click="save()" :loading="saving">Salvar</lms-button>
        
        <lms-button class="btn-danger" :disabled="false" @click="close()" :loading="false">Fechar</lms-button>
      
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: {
    newtopic: {
      type: Object,
      required: false,
      default: function() {
        return {  };
      }
    }
  },
  data() {
    return {
      saving:false,
      courses: [],
      course: null,
      modules: [],
      module: null
    };
  },
  methods: {
    save() {
      
      const path = this.$global.endpoint + "/forum/topic/save";
      
      this.newtopic.module = this.module;

     
      if((this.course != null && this.module != null) || (this.course == null && this.module == null)){
         
        this.saving = true;

        axios
          .post(path, {
            topic: this.newtopic
          })
          .then(res => {
            this.saving = false;
            this.$notify({
              type: "success",
              group: "foo",
              title: "Concluído",
              text: "Tópico cadastrado com sucesso"
            });
            this.$emit("close");
          })
          .catch(error => {
            this.saving = false;
            console.error(error);
            this.$notify({
              type: "error",
              group: "foo",
              title: "Erro",
              text: error.response.data.error
            });
          });
         
      }else{
        this.$notify({
            type: "error",
            group: "foo",
            title: "Error",
            text: "Necessário informar o módulo"
          }); 
      }
       console.log("course null?", this.course, this.module)

    },
    close() {
      this.$emit("close");
    },
    getCourses() {

      const path = this.$global.endpoint + "/course/getall";

      axios
        .get(path)
        .then(res => {
          this.courses = res.data;
          console.log("returned getCourses")
        })
        .catch(error => {
          console.error(error);
        });
    },
     getModules() {
      
      const path = this.$global.endpoint + "/module/getall";

      axios
        .post(path, {
          courseId: this.course
        })
        .then(res => {
          this.modules = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    onChangeCourse(event){
       
      this.course = event.target.value;

      console.log(this.course)
      console.log("onChangeCourse")
      
      this.modules = null;
      this.module = null;

      if (this.course != null && this.course != ''){
        this.getModules();
        
      }else{
        this.course = null;
        
      }
    },
    onChangeModule(event){

      this.module = event.target.value;
      console.log(this.module)
      console.log("onChangeModule");

      if (this.module == null || this.module == ''){
        this.module = null;
      }
    },
  },
  created() {
    this.getCourses();
  }
};
</script>
